// API related actions
export const FETCHING_BACK_ORDERS = '@@toyota/FETCHING_BACK_ORDERS';
export const FETCHED_BACK_ORDERS = '@@toyota/FETCHED_BACK_ORDERS';
export const FETCHED_BACK_ORDERS_FAILED = '@@toyota/FETCHED_BACK_ORDERS_FAILED';
export const DOWNLOADING_BACK_ORDERS = '@@toyota/DOWNLOADING_BACK_ORDERS';
export const DOWNLOADED_BACK_ORDERS = '@@toyota/DOWNLOADED_BACK_ORDERS';
export const DOWNLOADED_BACK_ORDERS_FAILED = '@@toyota/DOWNLOADED_BACK_ORDERS_FAILED';
// complementary actions
export const CHANGE_BACK_ORDERS_LIST_PAGE = '@@toyota/CHANGE_BACK_ORDERS_LIST_PAGE';
export const CHANGE_BACK_ORDERS_LIST_PAGE_SIZE = '@@toyota/CHANGE_BACK_ORDERS_LIST_PAGE_SIZE';
export const CLEAR_BACK_ORDERS_LIST = '@@toyota/CLEAR_BACK_ORDERS_LIST';
export const CHANGE_BOX_TEXT_FILTER = '@@toyota/CHANGE_BOX_TEXT_FILTER';
export const CHANGE_PART_CODE_TEXT_FILTER = '@@toyota/CHANGE_PART_CODE_TEXT_FILTER';
export const CHANGE_INVOICE_QUANTITY_TEXT_FILTER = '@@toyota/CHANGE_INVOICE_QUANTITY_TEXT_FILTER';
export const CHANGE_INVOICE_BACK_ORDERS_TEXT_FILTER = '@@toyota/CHANGE_INVOICE_BACK_ORDERS_TEXT_FILTER';
export const CHANGE_NATIONAL_BACK_ORDERS_TEXT_FILTER = '@@toyota/CHANGE_NATIONAL_BACK_ORDERS_TEXT_FILTER';
export const CHANGE_REQUESTER_1_TEXT_FILTER = '@@toyota/CHANGE_REQUESTER_1_TEXT_FILTER';
export const CHANGE_REQUESTER_2_TEXT_FILTER = '@@toyota/CHANGE_REQUESTER_2_TEXT_FILTER';
export const CHANGE_REQUESTER_3_TEXT_FILTER = '@@toyota/CHANGE_REQUESTER_3_TEXT_FILTER';
export const CLEAR_TEXT_FILTER = '@@toyota/CLEAR_TEXT_FILTER';
export const CLEAR_URL_BACK_ORDERS = '@@toyota/CLEAR_URL_BACK_ORDERS';
